'use client';

import Link from 'next/link';
import paths from '@/paths';
import styles from './MobileProfileOptions.module.css';
import { signOut } from 'next-auth/react';

interface IMobileProfileOptionsProps {
  handleClose: () => void;
}

export const MobileProfileOptions = ({ handleClose }: IMobileProfileOptionsProps) => {
  const logout = async () => await signOut()

  return (
    <div className="flex flex-col gap-2">
      <div>
        <Link href={paths.account.bookings()} className={styles.option} onClick={handleClose}>
          Bookings
        </Link>
        <Link href={paths.account.myTours()} className={styles.option} onClick={handleClose}>
          My Tours
        </Link>
        <Link href={paths.account.myAgency()} className={styles.option} onClick={handleClose}>
          My Agency
        </Link>
        <Link href={paths.profile()} className={styles.option} onClick={handleClose}>
          Profile
        </Link>
        <div className={styles.separator}></div>
        <div className={`${styles.option} ${styles.red}`} onClick={logout}>
          Log out
        </div>
      </div>
    </div>
  );
};
